import { useMutation, useQueryClient } from 'react-query';
import { API } from 'aws-amplify';
import { createMeeting } from '../../graphql/mutations';
import QUERY_CACHE_KEY from '../../constants/QueryCacheKey';

function useRequestMeetingMutation(owner, options = {}) {
  const client = useQueryClient();

  return useMutation(
    (input) => {
      return API.graphql({
        query: createMeeting,
        variables: {
          input: {
            owner,
            ...input,
          },
        },
      });
    },
    {
      ...options,
      onSuccess: (res) => {
        client.invalidateQueries(QUERY_CACHE_KEY.userMeetings(owner));
        if ('function' === typeof options.onSuccess) {
          options.onSuccess(res);
        }
      },
    }
  );
}

export default useRequestMeetingMutation;
